<div class="container-lg mt-4">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    @if (claim) {
                        <div class="col-12">
                            <div class="section-heading mb-4">
                                <span>Submit employer claim form for:&nbsp;{{ claim.accountStudent?.firstName }}&nbsp;{{ claim.accountStudent?.lastName }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mb-4">
                                <div class="heading-xs mb-4 text-center">There are two ways to submit the employer claim form:</div>
                            </div>
                        </div>
                        <div class="row mb-5">
                            <div class="col-12 col-lg-6 mb-4 mb-lg-0">
                                <div class="row">
                                    <div class="col-12 col-sm-10 col-md-8 mx-auto">
                                        <div class="caption d-flex mb-4">
                                            <i class="fa-solid fa-circle-1 me-2"></i>
                                            <div class="ps-2">Obtain a physical copy of the employer form, then upload the completed form to Dewar</div>
                                        </div>
                                        <div class="mb-3">
                                            <button
                                                type="button"
                                                class="btn btn-outline-primary w-100"
                                                (click)="onGenerateEmployerForm()"
                                                [disabled]="isDownloading"
                                                [class.btn--waiting]="isDownloading">
                                                <span class="btn-text">Download employer form</span>
                                            </button>
                                        </div>
                                        <div class="divider">THEN</div>
                                        <div class="mb-4">
                                            <button type="button" class="btn btn-outline-primary w-100" (click)="onUploadEmployerForms()">Upload employer form</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="row">
                                    <div class="col-12 col-sm-10 col-md-8 mx-auto">
                                        <div class="caption d-flex mb-4">
                                            <i class="fa-solid fa-circle-2 me-2"></i>
                                            <div class="ps-2">Or, email an electronic version of the form to the employer to be completed online</div>
                                        </div>
                                        <!-- @if (!emailProvided) { -->
                                        <form [formGroup]="employerForm">
                                            <fieldset formGroupName="parentEmployer">
                                                <div class="form-group mb-4">
                                                    <label for="email" class="form-label">Enter recipient's email address to enable this option</label>
                                                    <input type="text" class="form-control" id="email" formControlName="emailAddress" appShowFieldErrors="Email" />
                                                </div>
                                            </fieldset>
                                        </form>
                                        <!-- } -->
                                        <div class="mb-3">
                                            <button
                                                type="button"
                                                class="btn btn-outline-primary w-100"
                                                (click)="onEmailEmployer()"
                                                [disabled]="!employerForm.valid || isEmailing"
                                                [class.btn--waiting]="isEmailing">
                                                <span class="btn-text">Send employer form via email</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
